import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-no-data',
    templateUrl: './nodata.component.html',
    styleUrls: ['./nodata.component.scss'],
    standalone: false
})
export class NoDataComponent implements OnInit {

  @Input() noDataTitle: string;
  @Input() noDataSubTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
